import Answer from '../../components/Result/Answer'
import Reflection from '../../components/Result/Reflection'
import ValuesList from '../../components/Result/ValuesList'
import { ResultType, StepResult } from '../../types/Result'

export const getResultComponent = (result: StepResult) => {
  const { type, response, stepData } = result

  // remove this when the API always returns a header
  const header = result.header || ''

  switch (type) {
    case ResultType.MULTIPLE_CHOICE:
    case ResultType.SCALE:
      return (
        <ValuesList
          response={response}
          header={header}
          stepData={stepData}
          type={type}
        />
      )
    case ResultType.OPEN_TEXT:
      return <Answer data={response.response} title={header} />
    case ResultType.INSIGHT:
    case ResultType.TEXT:
      return <Reflection result={result} />
    default:
      return null
  }
}
